import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';

export const adjustCalibrationScoreForGraph = (
  calibrationScore: number,
  calibrationFraming: CalibrationFraming,
) => {
  return calibrationFraming === 'bias'
    ? 6 - calibrationScore
    : calibrationScore;
};
